module.exports = __webpack_public_path__ + "media/email-unsubscribe/unsub-success-6a507b3c.png";